import { useQuery } from "react-query";

import { getvisits } from "../../../../MyApi/sb/vistits";

import icons from "../../../../Data/icons";
import classes from "./attachModal.module.css";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../../UI/spinner";

const VisitModal = ({ closeModal, rowId }) => {
  const { data ,isLoading} = useQuery("getvisits", getvisits);
  const { t } = useTranslation();

  const CloseIcon = icons.close;
  const TimeLineIcon = icons.timeline;
  const UserIcon = icons.user;
  const DateIcon = icons.date;
  const Location = icons.location;

  const showData = data?.data || [];
  const visitShow = showData.find((visit) => visit.id === rowId) ||{} ;
  const {
    id,
    employe,
    sb_branch_device_id,
    lat,
    long,
    hr_attendance_id,
    type,
    operation,
    start_date,
    end_date,
    note,
    out_lat,
    out_long,
    out_sb_branch_device_id,
    out_type,
    out_operation,
    out_note,
  } = visitShow;
  const northEastLat = lat + 0.1; // Define the bounds
const northEastLong = long + 0.1;
const southWestLat = lat - 0.1;
const southWestLong = long - 0.1;

if(isLoading){
  return <LoadingSpinner/> 
}
  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تفاصيل الزيارات</h2>
        </div>
        <div className={classes.modalBody}>
          {!data ? (
            <div> no data avalible</div>
          ) : (
            <div class="user-profile">
              <div class="post-about card-body">
                <div className="row">
     <div className="col-lg-6">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="icon">
                        <TimeLineIcon />
                      </div>
                      <div>
                        <h5 className="mb-1">#</h5>
                        <p>{id}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <UserIcon />
                      </div>
                      <div>
                        <h5 className="mb-1">الموظف</h5>
                        <p>{employe}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <DateIcon />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("start_date")}</h5>
                        <p>{start_date}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <DateIcon />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("end_date")}</h5>
                        <p>{end_date}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("lat")}</h5>
                        <p>{lat}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("long")}</h5>
                        <p>{long}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("Note")}</h5>
                        <p>{note}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("Type")}</h5>
                        <p>{type}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("Opreation")}</h5>
                        <p>{operation}</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul className="list-group">
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("out_lat")}</h5>
                        <p>{out_lat}</p>
                      </div>
                    </li>

                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("out_long")}</h5>
                        <p>{out_long}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("out_sb_branch_device_id")}</h5>
                        <p>{out_sb_branch_device_id}</p>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="icon">
                        <Location />
                      </div>
                      <div>
                        <h5 className="mb-1">{t("out_sb_branch_device_id")}</h5>
                        <iframe src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13674.399307080672!2d${long}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f79d6842d9821d%3A0xfe2c6f7458ce971f!2z2LTYsdmD2Kkg2KfZhNix2LPYp9mE2Ycg2YTZhNiq2YLYs9mK2Lc!5e0!3m2!1sar!2seg!4v1725189568517!5m2!1sar!2seg`}  width="600" height="450" className="img-fluid" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                    </li>
                  </ul>
                </div>
                </div>
           
              </div>
            </div>
          )}{" "}
        </div>
      </div>
    </div>
  );
};

export default VisitModal;
